module.exports = __webpack_public_path__ + "img/pin(circle-x-large-004d40)-icon(awesome-home-medium)-@2x.3b43e269.png";